<template>
    <div>
        <div class="top">
<!--        <div class="flex">-->
<!--            <div :class="{'active':index == activeClass}" :key = "item.title" v-for="(item,index) in numList" @click="getListDats(1,index)">-->
<!--                 <p class="flex-num">{{item.title}}</p>-->
<!--                <p class="flex-name">{{item.value}}</p>-->
<!--            </div>-->
<!--        </div>-->
        </div>
        <p style="margin-bottom: 15px;color: rgba(0,0,0,.65)">登录网站排行榜</p>
        <div class="flex" >

            <div><a-button class="top_btn" type="primary"   @click="exportList()"  >
                批量导出
            </a-button>
                <span style="margin-left: 8px">
        <template v-if="hasSelected">
          {{ `选中 ${selectedRowKeys.length} 项` }}
        </template></span></div>
            <div class="search-group flex">
              <span class="name" style="position: relative;top: 5px;margin-right: 10px">售后：</span>
              <a-input  v-model="search.aftermarket_name" class="search-input" placeholder="请输入售后搜索" allowClear/>
<!--              <span class="name" style="position: relative;top: 5px;margin-right: 10px">公司团队：</span>-->
<!--              <a-select v-model="search.a_team_customer_service_id	" placeholder="请选择"   allowClear  style="width: 200px;margin-right:10px" >-->
<!--                <a-select-option :value="item.value" :key="index" v-for="(item,index) in teamList">-->
<!--                  {{item.name}}-->
<!--                </a-select-option>-->
<!--              </a-select>-->
               <span class="name" style="position: relative;top: 5px;margin-right: 10px">建站类型：</span>
                <a-select v-model="search.site_type	" placeholder="请选择"   allowClear  style="width: 200px;margin-right:10px" >
                  <a-select-option :value="item.value" :key="index" v-for="(item,index) in siteTypeList">
                    {{item.name}}
                  </a-select-option>
                </a-select>
                <span class="name" style="position: relative;top: 5px;margin-right: 10px">上线日期：</span>
                <a-range-picker  style="width: 200px;margin-right:10px"
                                 format="YYYY-MM-DD"  :ranges="{ '近一周': [moment(getBeforeDate(7), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')], '近一个月': [moment(getBeforeDate(30), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')], '近三个月': [moment(getBeforeDate(90), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')], '近半年': [moment(getBeforeDate(180), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')], '近一年': [moment(getBeforeDate(365), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')] }"
                                 v-model="search.online_date"
                />
              <span class="name" style="position: relative;top: 5px;margin-right: 10px">日期：</span>
              <a-range-picker  style="width: 200px;margin-right:10px"
                               format="YYYY-MM-DD"  :ranges="{ '近一周': [moment(getBeforeDate(7), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')], '近一个月': [moment(getBeforeDate(30), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')], '近三个月': [moment(getBeforeDate(90), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')], '近半年': [moment(getBeforeDate(180), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')], '近一年': [moment(getBeforeDate(365), 'YYYY-MM-DD'), moment(getNowTime(), 'YYYY-MM-DD')] }"
              v-model="search.search_date"
              />
               <span class="name" style="position: relative;top: 5px;margin-right: 10px">客户名称：</span>
                <a-input  v-model="search.company" class="search-input" placeholder="请输入客户名称搜索" allowClear/>
                <a-button type="primary" class="top_btn" @click="getList()">搜索</a-button>
                <a-button type="danger" class="top_btn" @click='()=>{this.search={company: "",a_team_customer_service_id:"", search_date:[],online_date:[], site_type:undefined };this.getList(1)}'>清空</a-button>
            </div>
        </div>
        <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id" @change="handleChange" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" >

        </a-table>

    </div>

</template>

<script>
import moment from 'moment';
    import API from "./api";
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [

        {
            title: "客户名称",
            key: "company",

            ellipsis: true,
            dataIndex: "company",
        },
      {
        title: "网站类型",
        key: "site_type_name",
        ellipsis: true,
        dataIndex: "site_type_name",
      },{
        title: "售后",
        key: "aftermarket_name",
        ellipsis: true,
        dataIndex: "aftermarket_name",
      },
        {
            title: "上线日期",
            key: "online_time",
            ellipsis: true,
            dataIndex: "online_time",
        },
        {
            title: "登录总次数",
            key: "total_login_num",
            ellipsis: true,
            dataIndex: "total_login_num",
          sorter: true,
        },
        {
            title: "近30天登录次数",
            key: "thirty_days_login_num_count",
            ellipsis: true,
            dataIndex: "thirty_days_login_num_count",
          sorter: true,
        },
        {
            title: "最后一次登录时间",
            key: "last_login_time",
            ellipsis: true,
            dataIndex: "last_login_time",
        },
        {
            title: "最后一次更新时间",
            key: "last_update_time",
            ellipsis: true,
            dataIndex: "last_update_time",
        },
      {
        title: "短信通知次数",
        key: "sen_sms_num",
        ellipsis: true,
        dataIndex: "sen_sms_num",
      },
      {
        title: "近期短信提醒日期",
        key: "last_sms_time",
        ellipsis: true,
        dataIndex: "last_sms_time",
      },

    ];
    export default {
        name: 'index',
        data() {
            return {
                numList:[
                     {title: "总网站数", value: ""},
                     {title: "近30天登录", value: ""},
                     {title: "近7天登录", value: ""},
                     {title: "昨天登录", value: ""},
                ],
                loading: true,
              siteTypeList:[],
              teamList:[],
                data: [],
                company:"",
                selectedRowKeys: [], // Check here to configure the default column
                columns,
                search: {
                  aftermarket_name:'',
                    company: "",
                    // a_team_customer_service_id:'',
                    search_date:[],
                    online_date:[],
                    site_type:undefined
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                activeClass:"0",
              page:1
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/DataStatistics/Active"; //设置左侧导航2-2 active
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods: {
          moment,
          getBeforeDate(n){
            var n = n;
            var d = new Date();
            var year = d.getFullYear();
            var mon=d.getMonth()+1;
            var day=d.getDate();
            if(day <= n){
              if(mon>1) {
                mon=mon-1;
              }
              else {
                year = year-1;
                mon = 12;
              }
            }
            d.setDate(d.getDate()-n);
            year = d.getFullYear();
            mon=d.getMonth()+1;
            day=d.getDate();
            let s = year+"-"+(mon<10?('0'+mon):mon)+"-"+(day<10?('0'+day):day);
            return s;
          },
         getNowTime(){
            let now = new Date()
            let year = now.getFullYear() //得到年份
            let month= now.getMonth() //得到月份
            let date= now.getDate() //得到日期
            let hour = ' 00:00:00' //默认时分秒 如果传给后台的格式为年月日时分秒，就需要加这个，如若不需要，此行可忽略
            month = month + 1
            month = month.toString().padStart(2, '0')
            date = date.toString().padStart(2, '0')
            var defaultDate = `${year}-${month}-${date}`
            console.log(defaultDate)
            return defaultDate
          },
          // 表格排序
          handleChange(pagination, filters, sorter) {
            if(sorter.order) {
              let sort=sorter.order=="ascend"?"ASC":"DESC"
              this.search.order_field=sorter.columnKey
              this.search.order_sort=sort
            }else{
              delete this.search.order_field
              delete this.search.order_sort
            }
            let seachData = JSON.parse(JSON.stringify(this.search))
            this.company=this.search.company
            API.service.GET_LIST({page: this.page || 1, ...seachData}).then(res => {
              this.data = res.data.data.list.data
              this.siteTypeList=res.data.data.siteTypeList
              this.teamList=res.data.data.teamList

              this.pagination.total=res.data.data.list.total
              this.pagination.pageSize=res.data.data.list.per_page
              this.pagination.current=res.data.data.list.current_page

              this.selectedRowKeys=[]
              this.loading = false
            })
          },
            exportList(){
                API.service.EXPORT({  company:this.company ,ids:this.selectedRowKeys }).then(res => {
                    window.open( `${this.$store.state.urlExper}${res.data.data.path.substr(1)}`  )
                    // this.selectedRowKeys=[]
                })
            },
            getListDats(page,type){
                type = parseInt(type) || 0;
                switch (type) {
                    case 0:
                        this.search.days=""
                        break;
                    case 1:
                        this.search.days=30;
                        break;
                    case 2:
                        this.search.days=7;
                        break;
                    case 3:
                        this.search.days=1;
                        break;
                    default:
                        break;
                }
                this.activeClass = type
                this.getList(page)
            },
            getList(page) {
                let seachData = JSON.parse(JSON.stringify(this.search))
                this.company=this.search.company
              if (seachData.search_date.length > 0) {
                seachData.search_date[0] = moment(seachData.search_date[0]).format('YYYY-MM-DD')
                seachData.search_date[1] = moment(seachData.search_date[1]).format('YYYY-MM-DD')
              }
              if(seachData.online_date.length>0){
                  seachData.online_date[0] = moment(seachData.online_date[0]).format('YYYY-MM-DD')
                  seachData.online_date[1] = moment(seachData.online_date[1]).format('YYYY-MM-DD')
              }
              this.page=page
                API.service.GET_LIST({page: this.page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.list.data
                  this.siteTypeList=res.data.data.siteTypeList
                  this.teamList=res.data.data.teamList
                    this.pagination.total=res.data.data.list.total
                    this.pagination.pageSize=res.data.data.list.per_page
                    this.pagination.current=res.data.data.list.current_page
                    this.selectedRowKeys=[]
                    this.loading = false
                })
            },
            getNum(page) {
                API.service.GET_NUM( ).then(res => {
                    this.numList = res.data.data
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
        },
        mounted() {
            this.getListDats(1,this.$route.query.days)
            this.getNum()
        }

    }
</script>
<style scoped>
    .inputs {
        display: inline-block;
        width: 70px
    }
    /*.search-group {*/
    /*    float: right;*/
    /*}*/
    .search-group .ant-select-selection--single{width: 200px}
    .search-group .search-input {
        width: 200px;
        height: 32px;
        margin: 0 8px 0 0 ;
    }
    .button-group {
        float: left;
    }
    #list_order {
        width: 50px;
    }
    .top .flex>div{ box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);padding:10px 16px;box-sizing: border-box;width: 20%;margin-bottom: 20px;text-align: center;cursor: pointer;}
    .top .flex>div.active{
        border: 1px solid #1890ff;
    }
    .top .flex>div .flex-num{font-size: 14px;color: rgba(0, 0, 0, 0.45);}
    .top .flex>div .flex-name{font-size: 24px;color: #000;}
</style>
